module.exports = __webpack_public_path__ + "img/gamesquare.c368cad8.png";